import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    paymentMethods: {
      '& .MuiInput-underline.Mui-disabled:before': {
        borderBottomStyle: 'solid',
      },
    },
  };
});

export default useStyles;
